import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { ThemeProvider, createTheme } from "@mui/material/styles";
import CssBaseline from "@mui/material/CssBaseline";
import { Container, Button, Typography } from "@mui/material";

import { AdminAuthProvider, useAdminAuth } from "./context/AdminAuthContext";
import AdminLayout from "./components/AdminLayout";
import Login from "./pages/Login";
import Dashboard from "./pages/Dashboard";
import Orders from "./pages/Orders";
import Users from "./pages/Users";
import Riders from "./pages/Riders";
import Payouts from "./pages/Payouts";
import Config from "./pages/Config";
import Wallets from "./pages/Wallets";
import Waitlist from "./pages/Waitlist";
import Feedback from "./pages/Feedback";

const theme = createTheme({
  palette: {
    primary: {
      main: "#E11D48",
    },
    secondary: {
      main: "#f50057",
    },
  },
});

function AccessDeniedScreen() {
  const { signOut } = useAdminAuth();
  return (
    <Container maxWidth="sm" sx={{ py: 8, textAlign: "center" }}>
      <Typography variant="h5" component="h2" gutterBottom>
        Access denied
      </Typography>
      <Typography color="text.secondary" sx={{ mb: 2 }}>
        Your account does not have admin access. Sign out and sign in with an
        admin account.
      </Typography>
      <Button variant="contained" onClick={() => signOut()}>
        Sign out
      </Button>
    </Container>
  );
}

function AdminRoutes() {
  const { user, isAdmin, loading } = useAdminAuth();

  if (loading) {
    return null;
  }

  if (!user) {
    return <Login />;
  }

  if (!isAdmin) {
    return <AccessDeniedScreen />;
  }

  return (
    <AdminLayout>
      <Container maxWidth="xl" sx={{ mt: 4, mb: 4 }}>
        <Routes>
          <Route path="/" element={<Dashboard />} />
          <Route path="/orders" element={<Orders />} />
          <Route path="/feedback" element={<Feedback />} />
          <Route path="/users" element={<Users />} />
          <Route path="/riders" element={<Riders />} />
          <Route path="/payouts" element={<Payouts />} />
          <Route path="/wallets" element={<Wallets />} />
          <Route path="/waitlist" element={<Waitlist />} />
          <Route path="/config" element={<Config />} />
        </Routes>
      </Container>
    </AdminLayout>
  );
}

function App() {
  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <Router>
        <AdminAuthProvider>
          <AdminRoutes />
        </AdminAuthProvider>
      </Router>
    </ThemeProvider>
  );
}

export default App;
